/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const PhoneUp: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12.445 15.998C12.802 15.999 16 13.634 16 13.332C16 13.03 12.421 10.775 12.111 10.775C11.802 10.775 10.762 12.021 10.482 12.16C10.201 12.299 8.451 12.249 6.501 10.299C4.55 8.35 3.883 6.105 3.883 5.752C3.883 5.4 5.51 4.311 5.555 4.055C5.6 3.799 3.411 0 3.055 0C2.7 0 0 3.281 0 3.555C0 3.828 0.247 7.346 4.701 11.799C9.155 16.252 12.089 15.996 12.445 15.998Z'
			/>
		</Svg>
	);
};

export { PhoneUp };
